/* eslint-disable react/prop-types */
import React from 'react';
import Icon from 'xpi-black-ui/Base/Icon';
import Bullet from 'xpi-black-ui/Base/Bullet';
import Tooltip from 'xpi-black-ui/Base/Tooltip';
import {
  SomaTable,
  SomaTableHead,
  SomaTableBody,
  SomaTableRow,
  SomaTableCell,
} from '@soma/react';
import waConfig from 'utils/waConfig';
import { FixedSizeList as List } from 'react-window';
import { SomaTableCellDiv } from './styles';

// eslint-disable-next-line react/prop-types
export default ({ proposals, onViewPush, cancelProposal }) => {
  const canBeCanceled = status => status === 'MOC' || status === 'Enviado Cliente';

  const onCancelProposal = (proposal) => {
    if (canBeCanceled(proposal.status.name)) {
      cancelProposal(proposal.codigoOrdem);
    }
  };

  return (
    <>
      <SomaTable caption="Tabela de Operações">
        <SomaTableHead>
          <SomaTableRow variant="header" style={{ backgroundColor: '#343439', paddingLeft: '10px' }}>
            <SomaTableCell header style={{ paddingLeft: '10' }}><span>Envio</span></SomaTableCell>
            <SomaTableCell header><span>Cliente</span></SomaTableCell>
            <SomaTableCell header><span>Ativo</span></SomaTableCell>
            <SomaTableCell header><span>Estrutura</span></SomaTableCell>
            <SomaTableCell header><Tooltip text="Data de Fixing para Ações e Data de Vencimento para Dólar."><span>Encerramento</span></Tooltip></SomaTableCell>
            <SomaTableCell header><span>Qtd.</span></SomaTableCell>
            <SomaTableCell header><Tooltip text="Preço da operação com base no preço referência do ativo objeto."><span>Preço unitário</span></Tooltip></SomaTableCell>
            <SomaTableCell header><Tooltip text="Comissão a dividir com base no preço referência do ativo objeto."><span>Comissão</span></Tooltip></SomaTableCell>
            <SomaTableCell header><span>Status</span></SomaTableCell>
            <SomaTableCell header><span>Push</span></SomaTableCell>
            <SomaTableCell header><span>Cancelar</span></SomaTableCell>
          </SomaTableRow>
        </SomaTableHead>
        <SomaTableBody>
          <SomaTableCellDiv>
            <List
              className="List"
              height={450}
              itemCount={proposals?.length}
              itemSize={50}
              itemData={proposals}
              width="100%"
            >
              {({ data, index, style }) => (
                <div className={index % 2 ? 'ListItemOdd' : 'ListItemEven'} style={style}>
                  <SomaTableRow key={data[index].id}>
                    <SomaTableCell style={{ padding: '0px 8px', maxWidth: '125px' }}>
                      <span className="status-name">{data[index].dataInclusao}</span>
                    </SomaTableCell>
                    <SomaTableCell>{data[index].cliente}</SomaTableCell>
                    <SomaTableCell>{data[index].ativo}</SomaTableCell>
                    <SomaTableCell>
                      <span className="status-name">{data[index].estrutura}</span>
                    </SomaTableCell>
                    <SomaTableCell>{data[index].vencimento}</SomaTableCell>
                    <SomaTableCell>{data[index].quantidade}</SomaTableCell>
                    <SomaTableCell>{data[index].precoFinal}</SomaTableCell>
                    <SomaTableCell>{data[index].comissao}</SomaTableCell>
                    <SomaTableCell>
                      <Bullet className="status-name" color={data[index].status.color}>{data[index].status.name}</Bullet>
                    </SomaTableCell>
                    <SomaTableCell>
                      <Icon
                        type="doc"
                        title="Ver push"
                        // eslint-disable-next-line no-undef
                        onClick={() => { onViewPush(data[index]); }}
                        data-wa={waConfig.event.proposalCenter.seePush}
                      />
                    </SomaTableCell>
                    <SomaTableCell>
                      <Icon
                        type="close"
                        title={canBeCanceled(data[index].status.name)
                          ? 'Cancelar proposta'
                          : 'Somente propostas com status MOC ou Enviado Cliente podem ser canceladas'}
                        onClick={() => onCancelProposal(data[index])}
                        className={canBeCanceled(data[index].status.name) ? '' : 'disabled'}
                      />
                    </SomaTableCell>

                  </SomaTableRow>
                </div>
              )}
            </List>
          </SomaTableCellDiv>
        </SomaTableBody>
      </SomaTable>
    </>
  );
};
